import { Tabs } from '../components/Tabs';

export const About = () => {
  const overview = (
    <>
      <h2>Overview</h2>
      <p>
        The main objective of UserExpression is to provide a better experience for artists and fans
        alike. By providing a single source of distribution for all things music, users no longer
        have to navigate to multiple websites in order to consume their favorite medias. In the
        current landscape, users have to visit separate sites in order to:
      </p>
      <ul style={{ width: '10rem' }}>
        <li>View Music Videos</li>
        <li>Stream Albums</li>
        <li>View Tour Dates</li>
        <li>Purchase Tickets</li>
        <li>Interact With Artists</li>
      </ul>
      <p>
        UserExpression is meant to combine all these elements into one site in order to better serve
        the artist and the fans
      </p>
    </>
  );
  const current = (
    <>
      <h2>Current Goals</h2>
      <ul style={{ width: 'fit-content' }}>
        <li>Create Social Media Style Website Built Around Music Distribution</li>
        <li>Provide A Digital Platform for Collaboration and Online Battles</li>
        <li>Create A Digital Ledger For Artists To Store and Distribute Media</li>
      </ul>
    </>
  );
  const future = (
    <>
      <h2>Future Goals</h2>
      <ul>
        <li>
          Internal Music Production/Mastering Software (possible partnership with a company like
          Protools)
        </li>
        <li>
          Check-in services for Venues to track how many users attend an event and which Artist they
          are there to see
        </li>
        <li>Beat Licensing</li>
      </ul>
    </>
  );

  const developer = (
    <>
      <h2>About the Developer</h2>
      <p>
        {`I've always had a bit of an inventive imagination. Problem solving is like a hobby. Over the
        years, I've had heaps of ideas. I never had the means to get them past the idea stage.`}
      </p>
      <p>
        {`After some bad years, Covid happened and changed the world. I made the choice to move to
        tech hub and enroll in a coding bootcamp. It was there that I learned the skills necessary
        to take my ideas from fantasy to reality.`}
      </p>
      <p>
        {`The concept for the site came from conversations with a sneakerhead who loved to battle. We
        had just met, I was buying some sneakers from him, and in the basic get to know ya type
        convo, I had told him I was learning to develop websites. He told me I should build a site
        made specifically for Battle Rapping. I took to the idea, but soon realized that it could be
        much more.`}
      </p>
      <p>
        {`Soon after our convo, I began building the site out in my head, then in the real world.
        While this endeavor is beyond the skills I leaned in school, I didn't let that stop me. I
        have been developing this app since February 2022. While I could most likely find a ton of
        libraries to do the heavy lifting, I have chosen to write as much of the code as possible so
        I can improve my skills and have a solid understanding of how the site functions as a whole.`}
      </p>
      <p>
        {`It seems I've reached the limits of my server space, as well as my skills. I am in need of funding to upgrade to paid server space as well as to be able to hire more experienced developers.`}
      </p>
    </>
  );

  const page = {
    tabs: ['Overview', 'Current Goals', 'Future Goals', 'About the Developer'],
    content: [overview, current, future, developer],
    modal: false,
  };
  return <Tabs page={page} />;
};
